<template>
  <b-container fluid>
    <template v-if="loading">
      <div class="d-flex justify-content-center bd-highlight mb-3">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </template>
    <!-- 
      dDevice: 450
      idAcquirer: 1
      idDeviceCategory: 1
      idDeviceStatus: 16
      idDeviceModel: 20
      idDeviceContractType: 1
      idMerchant: 257
      idSaleChannel: 1
      serialNumber: "524-300-214"
      logicNumber: "137170088"
      createdDate: "2017-05-26T02:59:16"
      lastUpdate: "2019-10-02T07:25:34"
      acquirerName: "PAGARME"
      deviceCategoryName: "POS"
      deviceStatusName: "AGUARDANDO REMOÇÃO"
      deviceModelName: "VX685"
      deviceContractTypeName: "ALUGUEL"
      merchantName: "EMPÓRIO DA CERVEJA"
      saleChannelName: "Wenov"
    -->
    <template v-else>
      <ValidationObserver ref="observer">
        <b-form layout="vertical" slot-scope="{ validate }" ref="formPoliticaComercial"
          @submit.prevent="validate().then(salvar)">
          <div class="row">
            <div class="col-md-3" v-if="sysAdminUser">
              <ValidationProvider rules="required" :name="`canaldevenda${_uid}`">
                <b-form-group label="Canal de Venda" slot-scope="{ valid, errors }">
                  <b-spinner v-if="!canalDeVenda.length" variant="primary" label="Spinning"></b-spinner>
                  <b-select v-else v-model="form.idSaleChannel" :disabled="sysAdminUser || readOnly" ref="canaldevenda"
                    :name="`canaldevenda${_uid}`" :state="errors[0] ? false : valid ? true : null">
                    <b-select-option :value="null"> Selecione </b-select-option>
                    <b-select-option :value="item.idSaleChannel" v-for="(item, index) in canalDeVenda"
                      :key="`canaldevenda-${index}`" required>
                      {{ item.name }}
                    </b-select-option>
                  </b-select>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>

            <div class="col-md-3" v-if="showMcc">
              <ValidationProvider rules="required" :name="`mcc${_uid}`">
                <b-form-group label="MCC" slot-scope="{ valid, errors }">
                  <b-spinner v-if="!mcc.length" variant="primary" label="Spinning"></b-spinner>
                  <b-select v-else v-model="form.idMcc" ref="mcc" :disabled="readOnly" :name="`mcc${_uid}`"
                    :state="errors[0] ? false : valid ? true : null">
                    <b-select-option :value="null"> Selecione </b-select-option>
                    <b-select-option :value="item.id" v-for="(item, index) in mcc" :key="`mcc-${index}`" required>
                      {{ item.description }}
                    </b-select-option>
                  </b-select>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>

            <div class="col-md-3" v-if="!edicaoMerchant">
              <ValidationProvider rules="required" :name="`nome${_uid}`">
                <b-form-group label="Nome" slot-scope="{ valid, errors }">
                  <b-input v-decorator="obrigatorio('nome', form.name)" ref="nome" v-model="form.name"
                    :disabled="readOnly" placeholder="Nome" :state="errors[0] ? false : valid ? true : null"
                    :name="`nome${_uid}`" />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-md-3">
              <b-form-group label="Valor Inicial">
                <b-input placeholder="Valor Inicial" v-model.lazy="form.startValue" v-money="money"
                  :disabled="readOnly" />
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Valor Final">
                <b-input placeholder="Valor Final" v-model.lazy="form.endValue" v-money="money" :disabled="readOnly" />
              </b-form-group>
            </div>
          </div>
          <h5>Aluguel Maquineta</h5>
          <div class="row">
            <div class="col-md-1">
              <b-form-group label="" class="check-no-label">
                <b-form-checkbox :disabled="readOnly" switch v-model="form.fgDeviceRent" @click="() => {
                  form.fgDeviceRent = !form.fgDeviceRent;
                }
                  " />
              </b-form-group>
            </div>

            <div class="col-md-3">
              <ValidationProvider rules="required" :name="`aluguel${_uid}`">
                <b-form-group label="Aluguel" slot-scope="{ valid, errors }">
                  <b-input placeholder="Aluguel" v-model.lazy="form.deviceRentFee" v-money="money"
                    :name="`aluguel${_uid}`" :disabled="!form.fgDeviceRent || readOnly"
                    :state="errors[0] ? false : valid ? true : null" />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-md-3">
              <ValidationProvider rules="required" :name="`aluguelpromocional${_uid}`">
                <b-form-group label="Aluguel Promocional" slot-scope="{ valid, errors }">
                  <b-input placeholder="Aluguel Promocional" v-model.lazy="form.deviceRentPromotionalFee"
                    v-money="money" :name="`aluguelpromocional${_uid}`" :disabled="!form.fgDeviceRent || readOnly"
                    :state="errors[0] ? false : valid ? true : null" />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-md-4">
              <b-form-group label="Validade Promoção">
                <!-- :disabled="!form.fgDeviceRent"
                style="width: 100%" -->
                <b-form-datepicker placeholder="Validade Promoção" :format="dateMask"
                  v-model.lazy="form.deviceRentPromotionExpireDate" locale="pt-BR" :start-weekday="0"
                  :hide-header="true" :show-decade-nav="false" :disabled="!form.fgDeviceRent || readOnly" />
              </b-form-group>
            </div>
          </div>

          <h5>PIX</h5>
          <a-tabs defaultActiveKey="0" :type="!readOnly ? 'editable-card' : 'card'" @edit="onEditPix">
            <a-tab-pane :tab="nomeAbaPix(item.idCardIssuer, index)" :key="index + ''" v-for="(item, index) in form.pix"
              :closable="item.idCardIssuer !== defaultCardIssuerPix">
              <DadosMeioPagamento :item="item" :key="`pix-${index}`" :ref="`pix-${index}`" :read-only="readOnly" />
            </a-tab-pane>
          </a-tabs>

          <h5>Débito</h5>
          <a-tabs defaultActiveKey="0" :type="!readOnly ? 'editable-card' : 'card'" @edit="onEditDebito">
            <a-tab-pane :tab="nomeAbaDebito(item.idCardIssuer, index)" :key="index + ''"
              v-for="(item, index) in form.debito" :closable="item.idCardIssuer !== defaultCardIssuerDebit">
              <div class="row" v-if="item.idCardIssuer !== defaultCardIssuerDebit">
                <div class="col-md-4">
                  <b-form-group label="Emissor de Cartão">
                    <b-select v-if="canalDeVenda.length" v-model="item.idCardIssuer">
                      <b-select-option :value="null">
                        Selecione
                      </b-select-option>
                      <b-select-option :value="itemCD.idCardIssuer" v-for="(itemCD, indexCD) in cartoesDebito"
                        :key="`emissordebito-${indexCD}`">
                        {{ itemCD.name }}
                      </b-select-option>
                    </b-select>
                    <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
                  </b-form-group>
                </div>
              </div>

              <DadosMeioPagamento :item="item" :key="`debito-${index}`" :ref="`debito-${index}`"
                :read-only="readOnly" />
            </a-tab-pane>
          </a-tabs>

          <h5>Crédito</h5>

          <a-tabs defaultActiveKey="0" :type="!readOnly ? 'editable-card' : 'card'" @edit="onEditCredito">
            <a-tab-pane :tab="nomeAbaCredito(itemC.aVista.idCardIssuer, index)" :key="index + ''"
              v-for="(itemC, index) in form.credito" :closable="itemC.aVista.idCardIssuer !== defaultCardIssuerCredit">
              <div class="row" v-if="itemC.aVista.idCardIssuer !== defaultCardIssuerCredit">
                <div class="col-md-4">
                  <b-form-group label="Emissor de Cartão">
                    <b-select v-if="canalDeVenda.length" :default-value="itemC.aVista.idCardIssuer"
                      v-model="itemC.aVista.idCardIssuer">
                      <b-select-option :value="null">
                        Selecione
                      </b-select-option>
                      <b-select-option :value="itemCD.idCardIssuer" v-for="(itemCD, indexCD) in cartoesCredito"
                        :key="`emissordebito-${indexCD}`">
                        {{ itemCD.name }}
                      </b-select-option>
                    </b-select>
                    <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
                  </b-form-group>
                </div>
              </div>

              <DadosMeioPagamento :item="itemC.aVista" :key="`avista-${index}`" :ref="`avista-${index}`"
                :read-only="readOnly" />
              <div class="air__utils__line mb-3">
                <div class="d-flex justify-content-between">
                  <h6>Crédito Parcelado</h6>
                  <b-button v-if="!readOnly" title="Adicionar nova parcela ao crédito parcelado" size="sm"
                    @click="adicionarParcela(itemC.parcelado)" class="mr-1 ml-2 custom-btn">
                    <i class="fe fe-plus"></i>
                  </b-button>
                </div>
              </div>

              <DadosMeioPagamento :item="updateCardIssuer(itemP, itemC.aVista.idCardIssuer)"
                :minMaxInstallment="minMaxInstallment(itemC.parcelado, indexP)" @changeInstallment="(i) => adjustInstallments(itemC.parcelado, i, true)
                  " :remover-labels="indexP > 0" :parcelado="true" :index="indexP"
                v-for="(itemP, indexP) in itemC.parcelado"
                @remover="(indexRetorno) => removerParcela(index, indexRetorno)" :key="`parcelado-${indexP}`"
                :ref="`parcelado-${indexP}`" :read-only="readOnly" />
            </a-tab-pane>
          </a-tabs>

          <div class="row" v-if="!readOnly">
            <div class="d-flex justify-content-end col-12">
              <b-button size="md" class="m-1" variant="danger" @click="cancel()">
                Cancelar
              </b-button>
              <b-button :disabled="loading" size="md" type="submit" class="m-1" variant="success">
                <span v-if="edicao">Salvar</span>
                <span v-else>Adicionar</span>
                <b-spinner small variant="primary" label="Spinning" v-show="loading"></b-spinner>
              </b-button>
            </div>
          </div>
        </b-form>
      </ValidationObserver>
    </template>
  </b-container>
</template>

<script>
import { CanalDeVendasResource } from "@/resources/CanalDeVenda.resource.js";
import { EmissorDeCartao } from "@/resources/EmissorDeCartao.resource.js";
import { MccResource } from "@/resources/Mcc.resource.js";
import { CARTAO } from "@/enums/cartao.js";
import { checkRole, cloneObject } from "@/utils/helpers.js";
import DadosMeioPagamento from "@/components/credenciamento/dados-meio-pagamento.vue";
import { mapActions, mapGetters } from "vuex";
import { VMoney } from "v-money";
import moment from "moment";

import { obrigatorio } from "@/decorators/form.rules.js";
import { dateMask, dateMaskRaw } from "@/decorators/form.masks.js";

const OBJETO_PADRAO = {
  idCardIssuer: null,
  installmentFrom: 1,
  installmentTo: 1,
  merchantFee: 0,
  tax: 0.0,
  availableDays: 1,
  idSaleChannelCommercialPolicy: 0,
  platformComission: 0,
  salesmanComission: 0,
  minTax: 0,
};

const MAX_INSTALLMENT = 18;
const MIN_INSTALLMENT = 2;
const DEFAULT_CARDISSUER_DEBIT = 90;
const DEFAULT_CARDISSUER_CREDIT = 91;
const DEFAULT_CARDISSUER_PIX = 92;
const DEFAULT_ID_ACQUIRER = 2; // id do pagseguro.... 2 = mercadopago
/**
 * quando o tipo do card issuer for -1, significa que será uma taxa padrao para todas as bandeiras
 *
 */
export default {
  name: "FormularioPoliticaComercial",
  components: {
    DadosMeioPagamento,
  },
  directives: { money: VMoney },
  computed: {
    sysAdminUser() {
      try {
        return checkRole("SystemAdmin");
      } catch (e) {
        return false;
      }
    },
    name() {
      try {
        return this.$store.getters.user.fullname;
      } catch (e) {
        return "";
      }
    },
    getIdSaleChannel() {
      try {
        return parseInt(this.$store.getters.user.salechannel);
      } catch (e) {
        return null;
      }
    },
  },
  data() {
    return {
      dateMask: dateMask,
      dateMaskRaw: dateMaskRaw,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: true,
      },
      maxInstallment: MAX_INSTALLMENT,
      // defaultCardIssuer: DEFAULT_CARDISSUER,
      defaultCardIssuerDebit: DEFAULT_CARDISSUER_DEBIT,
      defaultCardIssuerCredit: DEFAULT_CARDISSUER_CREDIT,
      defaultCardIssuerPix: DEFAULT_CARDISSUER_PIX,
      loading: false,
      mcc: [],
      salechannelNegotiation: [],
      canalDeVenda: [],
      cartoesDebito: [],
      pix: [],
      cartoesCredito: [],

      form: {
        idSaleChannelCommercialPolicy: 0,
        name: "",
        idSaleChannel: null,
        deviceRentFee: 0,
        idMcc: 0,
        fgDeviceRent: false,
        deviceRentPromotionExpireDate: null,
        deviceRentPromotionalFee: 0,
        idAcquirer: DEFAULT_ID_ACQUIRER,
        startValue: "",
        endValue: "",
        type: 0,
        items: [],
        debito: [],
        pix: [],
        credito: [
          //{
          // aVista: {},
          // parcelado: []
          //}
        ],
      },
    };
  },
  props: {
    item: {
      type: Object,
      default: () => null,
    },
    edicao: {
      type: Boolean,
      default: () => false,
    },
    edicaoMerchant: {
      type: Boolean,
      default: () => false,
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    showMcc: {
      type: Boolean,
      default: () => true,
    },
  },
  watch: {},
  methods: {
    obrigatorio: obrigatorio,
    ...mapActions(["saleChannel", "cardIssuer"]),
    ...mapGetters([
      "getSaleChannel",
      "getCardIssuerDebit",
      "getCardIssuerCredit",
    ]),
    cancel() {
      // voltar para a lista....
    },
    onEditDebito(targetKey, action) {
      this[`${action}Debito`](targetKey);
    },

    onEditPix(targetKey, action) {
      this[`${action}Pix`](targetKey);
    },
    addPix(event) {
      if (!this.form.pix.length)
        this.form.pix.push({ ...OBJETO_PADRAO });
    },

    onEditCredito(targetKey, action) {
      this[`${action}Credito`](targetKey);
    },
    addDebito(event) {
      this.form.debito.push({ ...OBJETO_PADRAO });
    },
    removeDebito(event) {
      this.form.debito.splice(event, 1);
    },
    addCredito(event) {
      this.form.credito.push({
        aVista: { ...cloneObject(OBJETO_PADRAO) },
        parcelado: [{ ...cloneObject(OBJETO_PADRAO) }],
      });

      // se jah existe o valor do idSaleChannelCommercialPolicy, atualzia nos novos itens
      if (this.form.idSaleChannelCommercialPolicy) {
        this.form.credito[
          this.form.credito.length - 1
        ].aVista.idSaleChannelCommercialPolicy = this.form.idSaleChannelCommercialPolicy;
        this.form.credito[
          this.form.credito.length - 1
        ].parcelado[0].idSaleChannelCommercialPolicy = this.form.idSaleChannelCommercialPolicy;
      }
      this.initAVista(this.form.credito[this.form.credito.length - 1].aVista);
      this.initParcelado(
        this.form.credito[this.form.credito.length - 1].parcelado[0]
      );
    },
    removeCredito(event) {
      this.form.credito.splice(event, 1);
    },
    getPoliticaComercial(id) { },

    getMcc() {
      MccResource.getKeyValue()
        .then((response) => {
          if (response.data.isSuccess) {
            this.mcc = response.data.payload;
          } else {
            throw "erro ao carregar mcc";
          }
        })
        .catch((e) => {
          // Surpress
        });
    },

    getSaleChannelNegotiation() {
      CanalDeVendasResource.getSaleChannelNegotiation()
        .then((response) => {
          if (response.data.isSuccess) {
            this.salechannelNegotiation = response.data.payload;

            if (this.salechannelNegotiation.length > 0) {
              OBJETO_PADRAO.platformComission = this.salechannelNegotiation[0].platformComission;
            }
          } else {
            throw "erro ao carregar canais de venda";
          }
        })
        .catch((e) => {
          // Surpress
        });
    },

    getCanaisDeVenda(id) {
      CanalDeVendasResource.getLista()
        .then((response) => {
          if (response.data.isSuccess) {
            this.canalDeVenda = response.data.payload;
          } else {
            throw "erro ao carregar canais de venda";
          }
        })
        .catch((e) => {
          // Surpress
        });
    },
    updateCardIssuer(item, idCardIssuer) {
      item.idCardIssuer = idCardIssuer;
      return item;
    },
    salvar(isValid) {
      let itens = [];

      if (isValid) {
        // ajusta os itens no formato necessario para salvar
        this.form.credito.forEach((item) => {
          itens.push(cloneObject(item.aVista));

          if (item.parcelado.length > 0) {
            itens.push(...cloneObject(item.parcelado));
          }
        });

        if (this.form.debito.length) {
          itens.push(...cloneObject(this.form.debito));
        }

        if (this.form.pix.length) {
          itens.push(...cloneObject(this.form.pix));
        }

        // clona e remove itens para reduzir o payload enviado
        if (!this.sysAdminUser) {
          this.form.idSaleChannel = this.getIdSaleChannel;
        }
        let parameters = cloneObject(this.form);

        // faz a multiplicacao de todos os itens...
        itens = cloneObject(
          itens.map((item) => {
            item.merchantFee = parseFloat(item.merchantFee); //  * 100;
            item.platformComission = parseFloat(item.platformComission); //  * 100;
            item.salesmanComission = parseFloat(item.salesmanComission); //  * 100;
            item.tax = parseFloat(item.tax); //  * 100;
            return item;
          })
        );

        parameters.items = itens;
        delete parameters.credito;
        delete parameters.debito;
        delete parameters.pix;

        // // faz a multiplicacao de todos os itens...
        // parameters.items = parameters.items.map(item => {
        //   item.merchantFee = parseFloat((item.merchantFee * 100) / 100).toFixed(
        //     2
        //   ); //  * 100;
        //   item.serviceFee = parseFloat(item.serviceFee).toFixed(2); //  * 100;
        //   item.salesmanComissionFee = parseFloat(
        //     item.salesmanComissionFee
        //   ).toFixed(2); //  * 100;
        //   item.tax = parseFloat(item.tax).toFixed(2); //  * 100;
        //   return item;
        // });

        // ajusta os valores inicial e final
        parameters.endValue = this.unmaskMoney(parameters.endValue);
        parameters.startValue = this.unmaskMoney(parameters.startValue);
        parameters.deviceRentPromotionalFee = this.unmaskMoney(
          parameters.deviceRentPromotionalFee
        );
        parameters.deviceRentFee = this.unmaskMoney(parameters.deviceRentFee);
        if (parameters.fgDeviceRent === false) {
          parameters.deviceRentPromotionExpireDate = null;
        }

        this.$emit("dados", parameters);
      }
    },
    adicionarParcela(item) {
      // temos os limites de parcelas?
      if (item.length >= 1) {
        if (
          item.length === MAX_INSTALLMENT - 1 ||
          item[item.length - 1].installmentFrom === MAX_INSTALLMENT
        ) {
          this.$notification["warning"]({
            message: "Limite alcançado",
            description:
              "Limite de parcelas alcançado, reorganize ou remova parcelas para adicionar novas",
          });
        } else {
          item.push(cloneObject(item[item.length - 1]));
          item[item.length - 1].installmentFrom =
            parseInt(item[item.length - 2].installmentFrom) + 1;

          // como adicionamos e tem mais de um ajustamos o valor
          this.adjustInstallments(item);
        }
      } else {
        // se esta zerado... adicionamos o padrao
        item.push(cloneObject(OBJETO_PADRAO));

        // e ajustamos os valores
        this.initParcelado(item[0]);
      }
    },
    removerParcela(indexCartao, indexItem) {
      this.form.credito[indexCartao].parcelado.splice(indexItem, 1);
      if (indexItem > 0) {
        this.adjustInstallments(
          this.form.credito[indexCartao].parcelado,
          indexItem - 1
        );
      }
    },
    nomeAbaCredito(idCardIssuer, index) {
      if (idCardIssuer === DEFAULT_CARDISSUER_CREDIT) {
        return "Padrão";
      }
      const cartoes = this.cartoesCredito.filter((cartao) => {
        return cartao.idCardIssuer === idCardIssuer;
      });
      return cartoes.length ? cartoes[0].name : `Bandeira ${index}`;
    },

    nomeAbaPix(idCardIssuer, index) {
      this.form.pix[0].idCardIssuer = DEFAULT_CARDISSUER_PIX;
      if (idCardIssuer === DEFAULT_CARDISSUER_PIX) {
        return "Padrão";
      }
    },

    nomeAbaDebito(idCardIssuer, index) {
      if (idCardIssuer === DEFAULT_CARDISSUER_DEBIT) {
        return "Padrão";
      }

      const cartoes = this.cartoesDebito.filter((cartao) => {
        return cartao.idCardIssuer === idCardIssuer;
      });
      return cartoes.length ? cartoes[0].name : `Bandeira ${index}`;
    },
    initParcelado(item) {
      // e ajustamos os valores
      item.installmentFrom = MIN_INSTALLMENT; // indicando a inclusao padrao
      item.installmentTo = MIN_INSTALLMENT; // indicando a inclusao padrao
    },
    initAVista(item) {
      // e ajustamos os valores
      item.installmentFrom = 1; // indicando a inclusao padrao
      item.installmentTo = 1; // indicando a inclusao padrao
    },
    /**
     * @param items o array dos itens parcelado
     * @param i indice que foi alterao
     * @param update indica que devemos proceder com a atualziacao das parcelas
     */
    adjustInstallments(items, i, update) {
      let localI = typeof i === "undefined" ? 0 : i;
      let localUpdate = typeof update === "undefined" ? false : i;
      items.forEach((item, index) => {
        if (index === 0) {
          // no primeiro item, verificamos o valor do proximo caso não sejamos o ultimo
          if (items.length - 1 > 0) {
            // existem outros, entao atualziamos o nosso valor com o proximo
            item.installmentTo = items[index + 1].installmentFrom;
          } else {
            item.installmentTo = item.installmentFrom;
          }
        } else if (index > 0 && index < items.length - 1) {
          // todos os itens no meio....
          item.installmentFrom = items[index - 1].installmentTo;
          item.installmentTo = items[index + 1].installmentFrom;
        } else if (items.length - 1 === index) {
          // ultimo item do array
          item.installmentTo = item.installmentFrom;
        }
      });
    },
    minMaxInstallment(items, index) {
      let min = 0;
      let max = 0;
      // temos item antes?
      if (typeof items[index - 1] !== "undefined") {
        min = items[index - 1].installmentFrom + 1;
      } else {
        min = MIN_INSTALLMENT; // minimo de parcelado
      }
      // temos item depois?
      if (typeof items[index + 1] !== "undefined") {
        if (items[index + 1].installmentFrom <= MAX_INSTALLMENT) {
          max = items[index + 1].installmentFrom - 1;
        } else {
          max = MAX_INSTALLMENT;
        }
      } else {
        max = MAX_INSTALLMENT;
      }

      return { min, max };
    },
    updateValuesEdit(item) {
      item.merchantFee = parseFloat(item.merchantFee).toFixed(2);
      item.salesmanComission = parseFloat(item.salesmanComission).toFixed(2);
      item.platformComission = parseFloat(item.platformComission).toFixed(2);
      item.tax = parseFloat(item.tax).toFixed(2);
      return item;
    },
    unmaskMoney(value) {
      return (
        parseInt(
          (value + "")
            .replace(/R\$/gi, "")
            .replace(/\s/gi, "")
            .replace(/\./gi, "")
            .replace(/,/gi, "")
        ) / 100
      );
    },
  },

  created() {
    this.getSaleChannelNegotiation();
    // eslint-disable-next-line
    this.getMcc();
    this.saleChannel().then((a) => {
      this.canalDeVenda = this.getSaleChannel();
    });
    this.cardIssuer({ cardType: CARTAO.DEBITO }).then((a) => {
      this.cartoesDebito = this.getCardIssuerDebit();
    });
    this.cardIssuer({ cardType: CARTAO.CREDITO }).then((a) => {
      this.cartoesCredito = this.getCardIssuerCredit();
    });

    // atualiza o objeto com os padroes
    if (this.edicao && this.item) {
      console.log("edit", this.item)
      this.form = cloneObject(this.item);
      // todos os valores retornam multiplicados por 100, precisamos dividir para colocar na tela
      try {
        this.form.startValue = parseFloat(this.form.startValue).toFixed(2);
        this.form.endValue = parseFloat(this.form.endValue).toFixed(2);
      } catch (e) {
        this.form["startValue"] = 0;
        this.form["endValue"] = 0;
      }
      try {
        this.form.deviceRentFee = parseFloat(this.form.deviceRentFee).toFixed(
          2
        );
        this.form.deviceRentPromotionalFee = parseFloat(
          this.form.deviceRentPromotionalFee
        ).toFixed(2);
      } catch (e) {
        this.form["deviceRentFee"] = 0;
        this.form["deviceRentPromotionalFee"] = 0;
      }

      // ----- cria a estrtura para a tela -----
      this.form = Object.assign(
        { debito: [], credito: [], pix: [] },
        this.form
      );
      // separa os itens

      // --- pix
      this.form.pix.push(
        ...this.form.items
          .filter((o) => {
            return o.cardType === CARTAO.PIX;
          })
          .map((o) => this.updateValuesEdit(o))
      );

      // --- debito
      this.form.debito.push(
        ...this.form.items
          .filter((o) => {
            return o.cardType === CARTAO.DEBITO;
          })
          .map((o) => this.updateValuesEdit(o))
      );

      // --- credito
      // -- aqui devemos separar por
      // ---- cardissuer
      // ---- e em seguida por parcelado ou a vista
      let itensCredito = this.form.items.filter((o) => {
        return o.cardType === CARTAO.CREDITO;
      });
      let itensPorCardIssuer = {};
      itensCredito.forEach((item, index) => {
        if (typeof itensPorCardIssuer[item.idCardIssuer] === "undefined") {
          itensPorCardIssuer[item.idCardIssuer] = [];
        }
        itensPorCardIssuer[item.idCardIssuer].push(item);
      });
      for (var item in itensPorCardIssuer) {
        let itensCreditoAVista = itensPorCardIssuer[item].filter((o) => {
          return o.installmentFrom === 1;
        });
        let itensCreditoParcelado = itensPorCardIssuer[item].filter((o) => {
          return o.installmentFrom !== 1;
        });
        this.form.credito.push({
          aVista: itensCreditoAVista[0]
            ? this.updateValuesEdit(itensCreditoAVista[0])
            : {},
          parcelado: itensCreditoParcelado.map((o) => this.updateValuesEdit(o)),
        });
      }

      if (!this.sysAdminUser) {
        this.form.idSaleChannel = this.getIdSaleChannel;
      }

      // transformamos a data recebida para um objeto
      try {
        if (this.form.deviceRentPromotionExpireDate !== undefined) {
          this.form.deviceRentPromotionExpireDate = moment(
            this.form.deviceRentPromotionExpireDate
          ).format(dateMaskRaw);
        }
      } catch (e) {
        //  this.form.deviceRentPromotionExpireDate = moment().format(dateMaskRaw);
      }
    } else {
      // nova politica
      var padrao_debito = cloneObject(OBJETO_PADRAO);

      // TOOD fazer amanha
      //  padrao_debito.mintax =this.salechannelNegotiation[0].tax;
      // adicionamos os valores padrao para comecao popular quando estamos adicionadno uma nova politica
      this.form.debito.push({ ...cloneObject(OBJETO_PADRAO) });
      this.form.pix.push({ ...cloneObject(OBJETO_PADRAO) });
      this.form.credito.push({
        aVista: { ...cloneObject(OBJETO_PADRAO) },
        parcelado: [{ ...cloneObject(OBJETO_PADRAO) }],
      });
      // ajusta os valores iniciais para os objetos
      this.form.credito[0].aVista.idCardIssuer = DEFAULT_CARDISSUER_CREDIT; // indicando a inclusao padrao
      this.initAVista(this.form.credito[0].aVista);

      this.form.credito[0].parcelado[0].idCardIssuer = DEFAULT_CARDISSUER_CREDIT; // indicando a inclusao padrao
      this.initParcelado(this.form.credito[0].parcelado[0]);

      this.form.debito[0].idCardIssuer = DEFAULT_CARDISSUER_DEBIT; // indicando a inclusao padrao
      this.form.pix[0].idCardIssuer = DEFAULT_CARDISSUER_PIX; // indicando a inclusao padrao
    }
  },
};
</script>

<style lang="scss" scoped>
.custom-btn {
  width: 20px;
  height: 20px;
  padding: 0;
  margin: 0;
  background-color: transparent;
  border-radius: 0;
  border: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    color: rgba(0, 0, 0, 0.65);
    font-size: 1.1em;
  }

  &:hover,
  &:focus,
  &:active {
    i {
      color: #4090e5;
    }

    border: 1px solid #4090e5;
    background-color: transparent;
  }
}

.check-no-label {
  margin-top: 38px;
}
</style>
